import * as React from "react";
import { Button } from "../../../../../../../../libs/components/libs/button/index";
import { FaTrashAlt, FaCopy } from "react-icons/fa";
import { SettingsPrintersForm } from "./printers.form";
import uuid from "uuid";
import shortid from "shortid";
import {Modal} from "../../../../../../../../libs/components/libs/layout/modal/index";
import {ModalContent} from "../../../../../../../../libs/components/libs/layout/modal/content";
import cloneDeep from "lodash/cloneDeep";
import {RotateLoader} from "../../../../../../../../libs/components/libs/loaders/rotate/index";
import { Tooltip } from "../../../../../../../../libs/components/libs/tooltip/index";
import {inject, observer} from "mobx-react";
import {MobxComponent} from "../../../../../../../mobx/components/index";
import {print_detail_list} from "../../../../../../../../libs/common/data/printing";
import {ConnectionIndicatorCircle} from "../../../../../../../../libs/components/libs/elements/connection-indicator/circle";
import {Tag} from "../../../../../../../../libs/components/libs/elements/tag";
import {
  ItemListContent,
  ItemListItem,
  ItemListWrapper,
} from "../../../../../../../../libs/components/libs/layout/item-list";
import {LinkTag} from "../../../../../../../../libs/components/libs/elements/link";

interface Props {}
interface State {
  panel_id: string | null;
  copy_index: number | null;
  copy_loading: boolean;
  remove_index: number | null;
  remove_loading: boolean;
}

@inject("store") @observer
export class SettingsPrinters extends MobxComponent<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      panel_id: null,
      copy_index: null,
      copy_loading: false,
      remove_index: null,
      remove_loading: false,
    };
  }

  setPanelID = (panel_id: string | null) => {
    this.setState({ panel_id });
  }
  create = (printer: RestaurantPrinter | null): RestaurantPrinter => {
    const r = this.injected.store.restaurant!;
    if (printer === null) {
      const _id = shortid.generate();
      return {
        _id: _id,
        name: "",
        api_key: `${r._id}|${_id}|${r.api}`,
        auto_print_enabled: false,
        auto_print_fail_mail: "",
        header: "",
        footer: "",
        paper: {
          font_size: 18,
          height: 210,
          width: 72,
          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          },
        },
        receipt: {
          details: print_detail_list(),
          dishes: {
            enabled: true,
            prices: true,
            option_prices: false,
            combo_choice_names: true,
          },
          totals: true,
        },
      };
    }
    return printer;
  }
  copy = async (index: number | null) => {
    if (index === null) return;
    await this.saveRestaurant({
      successMsg: "Printer copied",
      process: (r) => {
        const printer = cloneDeep(r.settings.printers[index]);
        printer._id = shortid.generate();
        printer.name = `${printer.name} - Copy`;
        printer.api_key = `${r._id}|${printer._id}|${uuid.v4()}`;
        r.settings.printers.push(printer);
        return {
          update: { $set: { "settings.printers": r.settings.printers } },
        };
      },
      before: () => this.setState({ copy_loading: true }),
      onSuccess: () => this.setState({ copy_loading: false, copy_index: null }),
      onFail: () => this.setState({ copy_loading: false }),
      onError: () => this.setState({ copy_loading: false }),
    });
  }
  remove = async (index: number | null) => {
    if (index === null) return;
    await this.saveRestaurant({
      successMsg: "Printer deleted",
      process: (r) => {
        r.settings.printers.splice(index, 1);
        return {
          update: { $set: { "settings.printers": r.settings.printers } },
        };
      },
      before: () => this.setState({ remove_loading: true }),
      onSuccess: () => this.setState({ remove_loading: false, remove_index: null }),
      onFail: () => this.setState({ remove_loading: false }),
      onError: () => this.setState({ remove_loading: false }),
    });
  }

  list = () => {

    const activePrinters = this.injected.store.ably.printers;
    const r = this.injected.store.restaurant!;

    if (r.settings.printers.length === 0)
      return null;

    return (
      <div className="m-t-4">
        <ItemListWrapper>
          <ItemListContent className="border-white-10">
            {r.settings.printers.map((item, i) => (
              <ItemListItem key={i} onClick={() => this.setPanelID(item._id)}>
                <div className="p-lr-4 p-tb-2 flex-line centered">
                  <ConnectionIndicatorCircle status={activePrinters.indexOf(item.api_key) !== -1 ? "connected" : "disconnected"}/>
                  <div className="m-l-3">
                    <p className="big font-semi-bold m-b-1">{item.name}</p>
                    <p>
                      API Key:
                      <Tag className="cursor-text m-l-1" onClick={(e) => {
                        e.stopPropagation();
                        const s = window.getSelection();
                        if (s) {
                          s.selectAllChildren( e.currentTarget );
                        }
                      }}>
                        {item.api_key}
                      </Tag>
                    </p>
                    <p className="m-t-1">Status: {activePrinters.indexOf(item.api_key) !== -1 ? "Connected" : "Disconnected"}</p>
                  </div>
                </div>
                <div>
                  <Tooltip text="Delete" width={65} position="top">
                    <Button
                      type="button"
                      color="transparent"
                      className="no-shadow"
                      paddinglr={10}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ remove_index: i });
                      }}>
                      <FaTrashAlt/>
                    </Button>
                  </Tooltip>
                  <Tooltip text="Copy" width={65} position="top">
                    <Button
                      type="button"
                      color="transparent"
                      className="no-shadow"
                      paddinglr={10}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ copy_index: i });
                      }}>
                      <FaCopy/>
                    </Button>
                  </Tooltip>
                </div>
              </ItemListItem>
            ))}
          </ItemListContent>
        </ItemListWrapper>
      </div>
    );
  }
  panel = () => {
    const r = this.injected.store.restaurant!;
    const item_id = this.state.panel_id;
    const active = item_id !== null;

    let initialValues = null;
    if (active) {
      if (item_id === "") {
        initialValues = this.create(null);
      }
      else {
        const item = r.settings.printers.find((p) => p._id === item_id);
        initialValues = this.create(item || null);
      }
    }

    return (
      <SettingsPrintersForm
        type={item_id === "" ? "create" : "edit"}
        initialValues={initialValues}
        close={() => this.setPanelID(null)}
      />
    );
  }
  modal_copy = () => {
    const r = this.injected.store.restaurant!;
    const { copy_index, copy_loading } = this.state;
    const printer = copy_index !== null ? r.settings.printers[copy_index] : null;
    return (
      <Modal
        width="sm"
        close={() => this.setState({copy_index: null})}
        closeButton={false}
        active={!!printer}>
        <ModalContent className="flex-l-r-center">
          <h4 className="">Copy Printer</h4>
          <p className="big underline">{printer && printer.name}</p>
        </ModalContent>
        <ModalContent className="flex-right">
          <Button type="button" className="m-r-2 width100 max100px" onClick={() => this.setState({copy_index: null})}>Cancel</Button>
          <Button type="button" className="width100 max100px" color="primary" onClick={() => this.copy(copy_index)}>
            {copy_loading && <RotateLoader size={2} color="white"/>}
            {!copy_loading && "Copy"}
          </Button>
        </ModalContent>
      </Modal>
    );
  }
  modal_delete = () => {
    const r = this.injected.store.restaurant!;
    const { remove_index, remove_loading } = this.state;
    const printer = remove_index !== null ? r.settings.printers[remove_index] : null;
    return (
      <Modal
        width="sm"
        close={() => this.setState({remove_index: null})}
        closeButton={false}
        active={remove_index !== null}>
        <ModalContent className="flex-l-r-center">
          <h4 className="">Delete Printer</h4>
          <p className="big underline">{printer && printer.name}</p>
        </ModalContent>
        <ModalContent>
          <p className="lhp big">Are you sure you want to delete this printer. Once deleted, it cannot be restored</p>
        </ModalContent>
        <ModalContent className="flex-right">
          <Button type="button" className="m-r-2 width100 max100px" onClick={() => this.setState({remove_index: null})}>Cancel</Button>
          <Button type="button" className="width100 max100px" color="primary" onClick={() => this.remove(remove_index)}>
            {remove_loading && <RotateLoader size={2} color="white"/>}
            {!remove_loading && "Delete"}
          </Button>
        </ModalContent>
      </Modal>
    );
  }

  render() {
    const { showMainSupport } = this.injected.store;
    const printer_id = this.state.panel_id;
    const active = printer_id !== null;
    return (
      <div className="p-4">

        <Button
          color="primary"
          size="xs"
          onClick={() => active ?
            this.setState({ panel_id: null }) :
            this.setState({ panel_id: "" })}>
          Create Printer
        </Button>

        {this.list()}

        {showMainSupport && <LinkTag className="block m-t-4 font-semi-bold" target="_blank" href="https://support.cloudwaitress.com/how-to-guides/setup-printing-for-windows">Read our printing setup guide</LinkTag>}

        {this.panel()}
        {this.modal_copy()}
        {this.modal_delete()}
      </div>
    );
  }

}
